<template>
  <div class="wrapper">
    <Header class="header" :val="headerTitle" :type="'all'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="full hr mg0">
          <div class="banner">
            <ul class="slideList">
              <li>
                <a>
                  <span class="img">
                    <!-- <img src="@/../static/img/mw/temp/temp_banner03.png" alt="" /> -->
                    <img src="https://www.welrixrental.co.kr/img_1/welmall_comm_img/1607670021420_zzim_banner01.png" alt="" />
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </section>

        <section class="hr" v-if="wishListLength > 0">
          <div class="sortArea">
            <div class="lcont">
              <span class="txtM">
                <em>내가찜한 상품</em>
                <span>
                  (
                  <i v-text="wishListLength"></i>
                  )
                </span>
              </span>
            </div>
            <div class="rcont">
              <button type="button" class="btn_s s" @click="deleteAllWishList"><span>전체삭제</span></button>
            </div>
          </div>

          <ul class="prdList">
            <li v-for="(wish, wishIndex) in wishList" :key="wishIndex">
              <div class="block">
                <div class="prdItem">
                  <div class="imgArea">
                    <div class="badgeArea">
                      <span class="badge" v-for="(topTags, topTagsIndex) in wish.tagInfos.topTags" :key="topTagsIndex">
                        <img :src="topTags.imgPath" />
                      </span>
                    </div>
                    <a class="img imgCover" @click="goProductDetail(wish.productIndex, wish.discntFlag)">
                      <img :src="wish.thumbnail" :alt="wish.displayName" />
                    </a>
                  </div>
                  <div class="infoArea">
                    <a class="tit row2" @click="goProductDetail(wish.productIndex, wish.discntFlag)">
                      <span v-text="wish.productName"></span>
                    </a>
                    <div class="txtItem">
                      <span v-text="wish.model"></span>
                    </div>
                    <div class="hashtag">
                      <span
                        v-for="(bottomTags, bottomTagsIndex) in wish.tagInfos.bottomTags"
                        :key="bottomTagsIndex"
                        v-text="bottomTags.tagName"
                      ></span>
                    </div>
                    <div class="price">
                      <span class="money del">
                        월
                        <span v-text="getConvertPrice(wish.rentalAmount)"></span>
                        원
                      </span>
                      <br />
                      <span class="money pointC1">
                        월
                        <em v-text="getConvertPrice(wish.cardDCrentalAmount)"></em>
                        원
                        <i>/제휴카드가</i>
                      </span>
                    </div>

                    <ul class="utilBtn">
                      <li>
                        <a :class="{ icoBtn: true, zzim: true, on: wish.wishItem }" @click="updateWishlist(wish.productIndex, wishIndex)">
                          <span>
                            찜 (
                            <i v-text="wish.wishCount"></i>
                            )
                          </span>
                        </a>
                        <!-- 클래스 on -->
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </section>

        <section class="hr" v-if="wishListLength == 0">
          <div class="sortArea">
            <div class="lcont">
              <span class="txtM">
                <em>내가찜한 상품</em>
                <span>
                  (
                  <i v-text="wishListLength"></i>
                  )
                </span>
              </span>
            </div>
          </div>

          <div class="resultMsg noItem">
            <p class="copy">찜한 상품이 없습니다.</p>
            <!-- TODO 이슈 홈쇼핑 히트템 코드 변경시 수정 필요 -->
            <button type="button" class="btn_l m" @click="$router.push('/product/category/9')">홈쇼핑 히트템 보러가기</button>
          </div>
        </section>

        <section class="hr" v-if="wishListLength == 0">
          <div class="titArea">
            <h2 class="titH4">이런 상품은 어떠세요?</h2>
          </div>
          <div class="slide goodsList" id="prd1">
            <ul class="slideList">
              <li v-for="(recomProduct, recomProductIndex) in recomProductList" :key="recomProductIndex">
                <a class="block" @click="goProductDetail(recomProduct.productCode, recomProduct.discntFlag)">
                  <span class="img">
                    <img :src="recomProduct.thumbnail" :alt="recomProduct.displayName" />
                  </span>
                  <em class="tit row2" v-text="recomProduct.productName"></em>
                  <p class="desc" v-text="recomProduct.model"></p>
                  <p class="price">
                    <span class="money" v-text="recomProduct.cardDCrentalAmount"></span>
                    원~/제휴카드가
                  </p>
                </a>
              </li>
            </ul>
            <div class="swiper-scrollbar"></div>
          </div>
        </section>
        <ConfirmPop v-if="confirmPop" @confirm="confirm" @cancel="cancel" @close="confirmPop = false">
          <p v-html="msg"></p>
        </ConfirmPop>
        <ConfirmPop v-if="confirmPop2" @confirm="confirm2" @cancel="cancel2" @close="confirmPop2 = false">
          <p v-html="msg"></p>
        </ConfirmPop>
        <MessagePop v-if="messagePop" @close="messagePop = false">
          <p v-html="msg"></p>
        </MessagePop>
      </div>
      <!-- content(e) -->
      <QuickMenu></QuickMenu>
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <transition v-if="wish" name="modal" appear>
      <div class="cartMsg" id="cartMsg">
        <div class="inner">
          <div class="msgR">
            <img src="@/../static/img/mw/content/icon_heart.png" />
            <p class="tit">{{ msg }}</p>
          </div>
        </div>
      </div>
    </transition>
    <infinite-loading spinner="circles" @infinite="infiniteHandler" v-show="p_flag == 'Y'" />
  </div>
</template>

<script>
import QuickMenu from '@/views/app/comm/QuickMenu';
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import * as customjs from '@/../static/js/m.front.js';
import { convertPrice } from '@/common/common.filter';
import ConfirmPop from '@/components/popup/ConfirmPop';
import ConfirmPop2 from '@/components/popup/ConfirmPop';
import { DELETE_CONFIRM, LOGIN_REQUIRE } from '@/store/message.type.js';
import MessagePop from '@/components/popup/MessagePop';
import InfiniteLoading from 'vue-infinite-loading';
export default {
  name: 'WishList',
  components: {
    QuickMenu,
    ConfirmPop,
    ConfirmPop2,
    MessagePop,
    InfiniteLoading,
  },
  data: function() {
    return {
      headerTitle: '찜한 상품',
      wish: false,
      wishList: [],
      wishListLength: -1,
      recomProductList: [],

      token: JwtService.getToken(),

      msg: null,
      confirmPop: null,
      confirmPop2: null,

      //페이징 관련
      loadingState: null,
      maxPage: null,
      p_flag: 'Y',
      initFlag: 'N',
      page: 1,

      messagePop: false,
    };
  },
  updated() {
    customjs.slideInit('#prd1', 0, false, 300, false, 'auto', 15);
  },
  mounted() {
    // 개인 찜 리스트 조회
    //this.selectWishList();

    // 추천상품 리스트
    ApiService.service('GET', '/product/recommend/myPage')
      .then(({ data }) => {
        if (data.isSucceed) {
          this.recomProductList = data.result.products;
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });
  },
  methods: {
    //스크롤
    infiniteHandler($state) {
      this.loadingState = $state;
      console.log(this.maxPage + 'page:' + this.page); // page No
      if (this.maxPage < this.page && this.maxPage != null) {
        this.p_flag = 'N';
        return false;
      }

      ApiService.service('GET', '/product/auth/wishlist', { params: { page: this.page, direction: 'DESC' } })
        .then(({ data }) => {
          console.log(data.result);
          this.initFlag = 'Y';

          if (data.isSucceed) {
            this.maxPage = data.result.totalPages;
            this.wishListLength = data.result.totalElements;
            for (let value of data.result.content) {
              this.wishList.push(value);
            }

            if (data.result.content.length == 0) {
              customjs.slideInit('#prd1', 0, false, 300, false, 'auto', 15);
            } else {
              this.page += 1;
              $state.loaded();
            }
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    selectWishList: function() {
      ApiService.service('GET', '/product/auth/wishlist')
        .then(({ data }) => {
          if (data.isSucceed) {
            this.wishList = data.result.content;
            this.wishListLength = data.result.totalElements;

            if (data.result.content.length == 0) {
              customjs.slideInit('#prd1', 0, false, 300, false, 'auto', 15);
            }
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    goProductDetail: function(productCode, discntFlag) {
      if (productCode != '0' && discntFlag != 'Y') {
        this.$router.push({ name: 'productDetail', params: { idx: productCode } });
      } else {
        this.msg = '단종된 상품입니다.';
        this.messagePop = true;
      }
    },
    getConvertPrice: function(value) {
      return convertPrice(value);
    },
    deleteAllWishList: function() {
      this.msg = DELETE_CONFIRM;
      this.confirmPop = true;
    },
    cancel: function() {
      this.confirmPop = false;
    },
    confirm: function() {
      for (let wish of this.wishList) {
        let param = new Object();

        let request = new Object();
        request.productIndex = wish.productIndex;

        param.request = request;
        param.serviceType = 'app';

        ApiService.service('DELETE', '/product/auth/wishlist/product', param)
          .then(({ data }) => {
            if (data.isSucceed) {
              //this.selectWishList();
              wish.wishItem = false;
              wish.wishCount -= 1;

              this.confirmPop = false;
              this.selectWishList();
            }
          })
          .catch(({ response }) => {
            console.log('error : ' + response);
          });
      }
    },
    updateWishlist: function(productIndex, wishIndex) {
      if (!this.token) {
        this.msg = LOGIN_REQUIRE;
        this.confirmPop2 = true;
      }

      let param = new Object();

      let request = new Object();
      request.productIndex = productIndex;

      param.request = request;
      param.serviceType = 'app';

      let method = '';
      let value = false;
      let count = 0;

      if (this.wishList[wishIndex].wishItem) {
        method = 'DELETE';
        value = false;
        count = -1;
      } else {
        method = 'POST';
        value = true;
        count = 1;
      }

      ApiService.service(method, '/product/auth/wishlist/product', param)
        .then(({ data }) => {
          if (data.isSucceed) {
            //this.selectWishList();
            this.wishList[wishIndex].wishItem = value;
            this.wishList[wishIndex].wishCount += count;
            if (method == 'DELETE') {
              this.msg = '찜해체';
            } else {
              this.msg = '찜성공';
            }
            this.wish = true;
            setTimeout(() => {
              this.wish = false;
            }, 500);
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    cancel2: function() {
      this.confirmPop2 = false;
    },
    confirm2: function() {
      this.$router.push({ name: 'login', params: { redirect: '/wishList' } });
    },
  },
};
</script>

<style lang="stylus" scoped>
.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.6s;
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.6s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;
}
</style>
